export default "__VITE_ASSET__bMG1SUQr__"